import type { ISerialize } from '@/objects/ISerialize';
import type { ExitStatus } from './../enums/ExitStatus';

export class StartingNumberSetFlagRequest implements ISerialize {
    public ExitStatus: ExitStatus;

    public StartNumberIds: number[];

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { ExitStatus?: ExitStatus; StartNumberIds?: number[] }) {
        this.ExitStatus = values.ExitStatus ?? 'Finished';

        this.StartNumberIds = values.StartNumberIds ?? [];
    }

    public serialize(): string {
        return (
            '{' +
            `"ExitStatus": ${this.ExitStatus == 'Finished' ? 10 : this.ExitStatus == 'REL' ? 20 : this.ExitStatus == 'DNC' ? 30 : this.ExitStatus == 'DNF' ? 40 : this.ExitStatus == 'DSQ' ? 50 : this.ExitStatus == 'DNS' ? 60 : this.ExitStatus == 'DNQ' ? 70 : this.ExitStatus == 'LAP' ? 80 : this.ExitStatus == 'None' ? -99 : 10}` +
            ',' +
            `"StartNumberIds": [ ${this.StartNumberIds.map((x) => JSON.stringify(x))} ]` +
            '}'
        );
    }

    /**
     * Creates an instance of StartingNumberSetFlagRequest from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { ExitStatus?: ExitStatus; StartNumberIds?: number[] }): StartingNumberSetFlagRequest {
        return new StartingNumberSetFlagRequest(values);
    }

    public static _FromServerJson(json: any): StartingNumberSetFlagRequest {
        return new StartingNumberSetFlagRequest({
            ExitStatus:
                json.ExitStatus == 10
                    ? 'Finished'
                    : json.ExitStatus == 20
                      ? 'REL'
                      : json.ExitStatus == 30
                        ? 'DNC'
                        : json.ExitStatus == 40
                          ? 'DNF'
                          : json.ExitStatus == 50
                            ? 'DSQ'
                            : json.ExitStatus == 60
                              ? 'DNS'
                              : json.ExitStatus == 70
                                ? 'DNQ'
                                : json.ExitStatus == 80
                                  ? 'LAP'
                                  : json.ExitStatus == -99
                                    ? 'None'
                                    : 'Finished',
            StartNumberIds: json.StartNumberIds,
        });
    }

    /**
     * Creates an instance of StartingNumberSetFlagRequest from another instance of StartingNumberSetFlagRequest.
     * @param other The StartingNumberSetFlagRequest you want to clone
     * @returns A cloned StartingNumberSetFlagRequest
     */
    public static FromOther(other: StartingNumberSetFlagRequest): StartingNumberSetFlagRequest {
        return StartingNumberSetFlagRequest._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return StartingNumberSetFlagRequest.FromOther(this);
    }

    static NAME_OF_CLASS = 'StartingNumberSetFlagRequest';
}
